import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Pagination, Scrollbar} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'tippy.js/dist/tippy.css';
import Link from 'next/link';
import {MdKeyboardArrowRight, MdKeyboardArrowLeft} from 'react-icons/md';
import Likes from '../buttons/likes';
import {ItemInterface} from '@api/item';
import resolveImage from '@helpers/resolve-image';
import {activeListingExists, getActiveListing, getItemPrice, getText} from '@helpers/item-card';
import Image from 'next/image';

const BidsCarousel = ({
  relatedItem,
  userAddress,
}: {
  relatedItem?: Array<ItemInterface>;
  userAddress: string;
}) => {
  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar]}
        spaceBetween={50}
        slidesPerView="auto"
        breakpoints={{
          240: {
            slidesPerView: 1,
          },
          565: {
            slidesPerView: 2,
          },
          1000: {
            slidesPerView: 3,
          },
          1100: {
            slidesPerView: 4,
          },
        }}
        navigation={{
          nextEl: '.bids-swiper-button-next',
          prevEl: '.bids-swiper-button-prev',
        }}
        className=" card-slider-4-columns !py-5"
      >
        {relatedItem &&
          relatedItem.map((item) => {
            const {id, image, optimizedImage, name, itemLikeCount} = item;
            // console.log({item});
            // const itemLink = image.split('/').slice(-1).toString().replace('.jpg', '');
            return (
              <SwiperSlide className="text-white" key={id}>
                <article key={id}>
                  <div className="dark:bg-black-green-2 dark:border-black-green-2 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                    <figure className="relative">
                      <Link href={`/item/${id}`}>
                        <a>
                          <div
                            className="w-full pb-[100%] bg-center bg-no-repeat bg-cover rounded-[0.625rem] mx-auto"
                            style={{
                              backgroundImage: `url('${resolveImage(
                                optimizedImage || image,
                                '/images/banner-default.png',
                              )}')`,
                            }}
                          ></div>
                        </a>
                      </Link>

                      <Likes like={item.itemLikeCount} id={Number(id)} isLiked={item?.isLiked} />
                    </figure>
                    <div className="mt-7 flex items-center justify-between">
                      <Link href={`/item/${id}`}>
                        <a>
                          <span className="font-display text-dark-navy hover:text-dark-grey text-base dark:text-white">
                            {name}
                          </span>
                        </a>
                      </Link>

                      {/* auction dropdown  */}
                      {/* <Auctions_dropdown classes="relative dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full" /> */}
                    </div>
                    <div className="mt-2 text-sm flex justify-between">
                      <span className="dark:text-white text-dark-grey mr-1 flex gap-x-1 items-center font-semibold">
                        {activeListingExists(item) ? (
                          <>
                            <Image
                              src={getActiveListing(item).Currency.logoUrl}
                              height={18}
                              width={18}
                              objectFit={'cover'}
                              alt={getActiveListing(item).Currency.name}
                            />
                            {getItemPrice(item)}
                          </>
                        ) : (
                          <span className="group-hover:text-dark-grey dark:text-grey text-dark-grey text-sm">
                            -
                          </span>
                        )}
                      </span>
                      <span className="text-grey">x{item?.supply}</span>
                    </div>

                    <div className={`mt-8 flex items-center justify-between`}>
                      {activeListingExists(item) ? (
                        <button
                          className="font-bold text-transparent bg-clip-text bg-green-gradation-light"
                          // onClick={() => dispatch(buyModalShow())}
                        >
                          <Link href={`/item/${id}`}>{getText(item, userAddress)}</Link>
                        </button>
                      ) : (
                        <button className="font-bold text-transparent">Not for Sale</button>
                      )}
                    </div>
                  </div>
                </article>
              </SwiperSlide>
            );
          })}
      </Swiper>
      {/* <!-- Slider Navigation --> */}
      <div className="group bids-swiper-button-prev swiper-button-prev shadow-white-volume absolute !top-1/2 !-left-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-base sm:!-left-6 after:hidden">
        <MdKeyboardArrowLeft />
      </div>
      <div className="group bids-swiper-button-next swiper-button-next shadow-white-volume absolute !top-1/2 !-right-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-base sm:!-right-6 after:hidden">
        <MdKeyboardArrowRight />
      </div>
    </>
  );
};

export default BidsCarousel;
